/**
 * Rubato: two things the cart drawer has to do that Horizon leaves undone.
 *
 * 1. Continue shopping closes the drawer in every state. The full drawer's own button does,
 *    but the empty state renders Horizon's link to a collection, which navigated away with
 *    the drawer still open behind it. Round 36, item 6a.
 * 2. Coming back from checkout with the browser's Back button restores the page from the
 *    back forward cache exactly as it was left, drawer open and no backdrop under it, because
 *    a modal dialog's open state survives the snapshot while the top layer does not. The
 *    drawer is closed on every pageshow, restored or not. Round 36, item 6b.
 */

const DRAWER = '#cart-drawer';

/** The dialog inside the cart drawer, if the drawer is on the page at all. */
function panel() {
  return document.querySelector(`${DRAWER} .theme-drawer__dialog`);
}

function closeDrawer() {
  const dialog = panel();
  if (!(dialog instanceof HTMLDialogElement)) return;
  const drawer = document.querySelector(DRAWER);
  // The component's own close runs the closing animation and restores focus.
  if (drawer && typeof (/** @type {any} */ (drawer).close) === 'function') {
    /** @type {any} */ (drawer).close();
  }
  if (dialog.open) dialog.close();
  dialog.classList.remove('theme-drawer__dialog--opening', 'theme-drawer__dialog--closing');
}

// Continue shopping, whichever of the two buttons the state happens to render.
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const button = target.closest('.cart-items__empty-button, .cart-drawer__continue');
  if (!button || !button.closest(DRAWER)) return;
  event.preventDefault();
  closeDrawer();
});

// Back from checkout, including a restore from the back forward cache.
window.addEventListener('pageshow', () => closeDrawer());

/**
 * Escape closes the cart drawer.
 *
 * Horizon opens it with its own drawer component rather than showModal, so the dialog's native
 * Escape never applies. Round 51's keyboard pass found the drawer could be opened from the
 * keyboard and not closed from it, which the brief asks for explicitly.
 */
document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;
    /* The drawer is a custom element wrapping a dialog, so the open state to read is the
       dialog's, not the wrapper's. */
    const dialog = panel();
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open) return;
    event.preventDefault();
    closeDrawer();
  },
  true
);
